// SPDX-FileCopyrightText: Copyright (c) 2025 Software GmbH, Darmstadt, Germany and/or its subsidiaries and/or its affiliates
// SPDX-FileContributor: Zead Alshukairi (planen-bauen 4.0 GmbH)
//
// SPDX-License-Identifier: Apache-2.0

import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pop-up',
  imports: [TranslateModule, MatButtonModule],
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent {

  @Input() popUpObj: { title: string, message: string, actions: { text: string, action: Function }[] };

  constructor() { }

  runAction(action: Function): void {
    action();
  }

}
